import { z } from 'zod';
import { IsoTimestamp } from './common';

export const FeatureFlagValue = z.union([z.boolean(), z.string(), z.number()]);
export type FeatureFlagValue = z.infer<typeof FeatureFlagValue>;

export const FeatureFlag = z.object({
  userId: z.string(),
  flagName: z
    .string()
    .regex(/^[a-z0-9_-]+$/)
    .min(1)
    .max(64),
  value: FeatureFlagValue,
  setByEmail: z.string().email(),
  setByUserId: z.string(),
  setAt: IsoTimestamp,
  expiresAt: IsoTimestamp.optional(),
});
export type FeatureFlag = z.infer<typeof FeatureFlag>;

export const SetFeatureFlagRequest = z.object({
  value: FeatureFlagValue,
  expiresAt: IsoTimestamp.optional(),
});
export type SetFeatureFlagRequest = z.infer<typeof SetFeatureFlagRequest>;
